import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  Phone,
  Mail,
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  ArrowUp,
  Award,
  Briefcase,
} from "lucide-react";
import { contactData } from "../mockData";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/aaj-engineer/count-visitor`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (data.status === "SUCCESS") {
          setVisitorCount(data.totalVisitors);
        }
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    };

    fetchVisitorCount();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight; // Hero ki height
      if (window.scrollY > heroHeight - 100) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about-us" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Awards", path: "/gallery", icon: Award },
    // { name: "Testimonials", path: "" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
    // { name: "Career", path: "/career", icon: Briefcase },
  ];

  const socialLinks = [
    { icon: Facebook, href: "#", color: "hover:text-white-500" },
    { icon: Instagram, href: "#", color: "hover:text-white-500" },
    { icon: Twitter, href: "#", color: "hover:text-white-500" },
    { icon: Linkedin, href: "#", color: "hover:text-white-500" },
  ];

  return (
   <footer
  className="relative overflow-hidden bg-gray-900 text-gray-300"
  style={{
    backgroundImage: "url('/aaj-home/footer-bg3.png')",
     backgroundSize: "fill",
    backgroundPosition: "center",  
    backgroundRepeat: "no-repeat",
  }}
>

      <div className="absolute inset-0 bg-gray/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="group flex items-center space-x-4 focus:outline-none focus:ring-0 focus:border-0"
            >
              <div className="flex items-start">
                <img
                  src="/aaj-home/footer2.png"
                  alt="Aaj Engineers Pvt. Ltd. Logo"
                  className="w-40 object-contain"
                />

              </div>

            </Link>
            <p className="text-gray text-xs pt-1" style={{ fontFamily: "Merriweather, serif" }}> Engineers & Consultants Pvt.Ltd</p>
            <p className="text-white-400 space-y-2 mt-4 text-justify">
              Founded in 2002, we provide expert structural engineering
              solutions across India for residential, commercial, and industrial projects.
              Committed to quality, safety, and sustainable design.
            </p>

            {/* Social Media Icons */}
            <div className="flex items-center space-x-4 mt-6">
              <a
                // href="https://www.facebook.com/profile.php?id=100063797752751" 
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-800 text-white hover:bg-[#3b5998] transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                // href="https://www.instagram.com/ashishconstructions/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-800 text-white hover:bg-[#E1306C] transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>


            </div>

          </div>
          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold text-white">Quick Links</h4>
            <ul className="grid grid-cols-2 gap-x-8 gap-y-4">
              {quickLinks.map((link) => {
                const isActive = location.pathname === link.path; // current link check
                return (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className={`group flex items-center transition-all duration-300
                  ${isActive ? "text-[#00B9F1]" : "text-white-400 hover:text-[#00B9F1]"}
                  focus:outline-none`} // white border remove
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4 mr-2 text-white-500 group-hover:translate-x-1 transition-transform duration-300"
                        fill="currentColor"
                        viewBox="0 0 320 512"
                      >
                        <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                      </svg>
                      <span className="transform group-hover:translate-x-2 transition-transform duration-300">
                        {link.name}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Contact Info */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold text-white flex items-center space-x-2">
              <span>Contact Info</span>
            </h4>

            <div className="space-y-6">
              <div className="group flex items-start space-x-4 p-4 rounded-xl bg-gray-800 hover:bg-gray-700 transition-colors duration-300">
                <MapPin className="w-6 h-6 text-white-500 mt-1 flex-shrink-0" />
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    contactData.address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white-300 focus:outline-none"
                >
                  {contactData.address}
                </a>
              </div>

              <div className="group flex items-start p-4 rounded-xl bg-gray-800 hover:bg-gray-700 transition-colors duration-300">

                <Phone className="w-6 h-6 text-white flex-shrink-0 mt-1" />


                <div className="flex flex-col ml-4">
                  <a href={`tel:${contactData.phone1}`} className="text-white focus:outline-none">
                    {contactData.phone1}
                  </a>
                </div>
              </div>



              <div className="group flex items-start space-x-4 p-4 rounded-xl bg-gray-800 hover:bg-gray-700 transition-colors duration-300">
                <Mail className="w-6 h-6 text-white-500 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <a
                    href={`mailto:${contactData.email}`}
                    className="block text-white-300 break-words focus:outline-none"
                  >
                    {contactData.email}
                  </a>
                  <a
                    href={`mailto:${contactData.email2}`}
                    className="block text-white-300 break-words focus:outline-none"
                  >
                    {contactData.email2}
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="w-full mt-12 border-t border-gray-700 pt-4 flex flex-col lg:flex-row gap-2 text-gray-800 bg-yellow-400 px-4 py-2">
        <div className="w-full lg:w-[35%] flex justify-center lg:justify-start">
          <p className="font-bold text-[15px] text-gray-800">
            © {new Date().getFullYear()} Aaj Engineers & Consultants Pvt. Ltd
          </p>

        </div>

        <div className="w-full lg:w-[10%] flex items-center justify-center space-x-1">
          <span className="text-gray-800 font-bold text-[15px]">Visitors:</span>
          <div className="flex space-x-1">
            {visitorCount
              .toString()
              .padStart(4, "0")
              .split("")
              .map((digit, index) => (
                <span
                  key={index}
                  className="bg-gray-800 text-white font-mono text-[15px] px-1 rounded-md shadow-inner border border-gray-700"
                >
                  {digit}
                </span>
              ))}
          </div>
        </div>

        <div className="w-full lg:w-[55%] flex justify-center lg:justify-end relative z-30">
          <a
            href="https://rightserveinfotechsystem.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer font-bold text-[15px] text-gray-800 hover:text-white transition-colors text-center lg:text-right focus:outline-none focus:ring-0 focus:border-0"
          >
            Design & Developed by RIGHT SERVE INFOTECH SYSTEM PVT.LTD
          </a>
        </div>

      </div>

      {/* Scroll to Top Button */}
      {showTopBtn && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-44 sm:bottom-28 right-1 group w-12 h-12 bg-gray-800 text-white rounded-full shadow-lg hover:bg-white hover:text-black transform hover:scale-110 transition-all duration-500 flex items-center justify-center z-40"
        >
          <ArrowUp className="w-6 h-6 transition-transform duration-300 group-hover:-translate-y-1" />
        </button>
      )}


      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/9970066936?text=Hello"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-60 sm:bottom-44 right-1 group w-12 h-12 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transform hover:scale-110 transition-all duration-500 flex items-center justify-center z-40 animate-spin-slow"
      >
        <FaWhatsapp className="w-6 h-6 sm:w-8 h-8" />
      </a>
    </footer>
  );
};

export default Footer;
